import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1064c7f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section is-paddingless"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "no-data py-4"
}
const _hoisted_4 = {
  "data-int": "attachments-no-data",
  class: "subtitle has-text-centered"
}

import { computed, provide, toRaw, watch, onBeforeMount } from "vue"
import { useStore } from "vuex"
//@ts-ignore
import VirtualList from "vue3-virtual-scroll-list"

import VirtualScrollCards from "@/components/common/VirtualScrollCards.vue"
import UtilityBlock from "@/components/common/UtilityBlock.vue"

import useDetailPage from "@/components/library/content/details/useDetailPage"
import { downloadOnClick } from "@/helpers/download"
import { useBreakpoints } from '@/helpers/responsiveBreakpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'Attachments',
  setup(__props) {

provide("eventHandlers", { select, navToWidgetContent })

const store = useStore()
const { showAttachments } = useDetailPage()
const { outerWidth } = useBreakpoints()

const isWidget = computed(() => store.getters['widgets/isWidget'])
const isIframe = window.top !== window.self

const contentLoaded = computed(() => store.state.content.isLoaded)
const isMobile = computed(() => {
  return outerWidth.value <= 768
})
const attachments = computed(() => {
  if (isMobile.value) {
    return store.getters["content/attachmentsAsMatrixMobile"]
  }
  return store.getters["content/attachmentsMatrix"]
})
const isLoading = computed(() => {
  return store.state.content.attachments.loading
})
const total = computed(() => {
  return store.state.content.attachments.total
})

async function getAttachments() {
  await store.dispatch("content/getAttachments")
}
async function navToWidgetContent(content: any) {
  await select(content)
}
async function select(content: any) {
  const dto = toRaw(content)
  const isRelatedMedia = dto.type === "media"
  const isFile = Object.hasOwn(dto, 'contentUrl')
    && Object.hasOwn(dto, 'name')
    && !Object.hasOwn(dto, 'type')

  if (isRelatedMedia) {
    store.dispatch("content/navigateToContent", { content })
  } else if (isFile) {
    await downloadOnClick(dto.contentUrl, dto.name, !isIframe)
  }
}

async function getMoreAttachments() {
  await store.dispatch("content/getMoreAttachments")
}

onBeforeMount(async () => {
  if (store.state.content.attachments.items.length === 0) {
    await getAttachments()
  }
})
watch(contentLoaded, async (value: boolean) => {
  if (value) {
    await getAttachments()
  }
})

return (_ctx: any,_cache: any) => {
  return (_unref(showAttachments))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (total.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createVNode(_unref(VirtualList), {
                "data-component": VirtualScrollCards,
                "data-sources": attachments.value,
                "extra-props": { isWidget: isWidget.value },
                class: "vs-card-list",
                "data-key": "id",
                onTobottom: getMoreAttachments
              }, {
                footer: _withCtx(() => [
                  _withDirectives(_createVNode(UtilityBlock, null, null, 512), [
                    [_vShow, isLoading.value]
                  ])
                ]),
                _: 1
              }, 8, ["data-sources", "extra-props"])
            ]))
          : (!total.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('assetsNotFound', { type: _ctx.$tc('attachment', 2) })), 1)
              ]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})